import { TemplateDescription } from '../types/TemplateDescription';

export const generateKey = (page: TemplateDescription) => {
  return `product${page.productId}${page.templateId.replaceAll('-', '')}`;
};
